/*
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-03-11 14:11:50
 * @LastEditTime: 2019-03-19 10:05:39
 */
import request from "@/plugins/axios/request";

// 获取菜单数据
export function queryMenuList(id) {
    return request({
        url: "/osmenucateory/queryosmenucateory",
        method: "post",
        data: { parentId: id,isMobile: false }
    });
}
// 通过address 或者id 获取跳转对象
export function menuqueryaddressid(MenuQueryDto) {
    if (MenuQueryDto){
        MenuQueryDto.isMobile = false;
    }
    return request({
        url: "/osmenucateory/menuqueryaddressid",
        method: "post",
        data: MenuQueryDto
    });
}
